import { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import StepRecipient from "./StepRecipient";
import StepOptions from "./StepOptions";
import Order from "~/model/order";

type TDesktopContactModalProps = {
  order: Order;
  open: boolean;
  onToggle: () => void;
  onOpenChat: (channel: number) => void;
}

const DesktopContactModal = ({ order, open, onToggle, onOpenChat }: TDesktopContactModalProps) => {

  const [selectedPerson, setSelectedPerson] = useState<any>(null);

  const clearSelectedPerson = () => {
    setSelectedPerson(null);
  }

  return (
    <Modal
      className="contact-modal"
      isOpen={open}
      toggle={onToggle}
      onClosed={clearSelectedPerson}
      centered
    >
      <ModalBody>
        <button type="button" className="btn-close" aria-label="Close" onClick={onToggle} />
        {!selectedPerson && <StepRecipient order={order} selectPerson={(person: any) => setSelectedPerson(person)} onOpenChat={onOpenChat} />}
        {!!selectedPerson && <StepOptions selectedPerson={selectedPerson} onOpenChat={onOpenChat} personRoleLabel={'Contact your '} />}
      </ModalBody>
    </Modal>
  );
}

export default DesktopContactModal;